module.exports = window["redfoxThankYou"]["adminUtils"];